<template>
  <div class="">
    <!-- <transition name="slide" mode="out-in"> -->
    <loading pic="loading1" v-if="loadingState" key="1" />

    <div v-else class="client__wrapper" key="2">
      <div class="clients__manipulate">
        <button
          type="submit"
          @click="newClient()"
          class="action_btn client__add"
        >
          <svg
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            fill="var(--purple)"
            width="40px"
            height="40px"
            viewBox="0 0 498.306 498.306"
            style="enable-background: new 0 0 498.306 498.306"
          >
            <g>
              <g>
                <path
                  d="M68.107,497.729c0.48,0.377,1.071,0.577,1.677,0.577h41.224c0.517,0,1.01-0.138,1.441-0.41l23.024-14.499h235.166
                    c1.418,0,2.587-1.091,2.688-2.509l0.871-13.155c0.096-1.438-0.961-2.698-2.393-2.845l-159.271-17.04l35.746-46.866l52.154,0.851
                    c0.729-0.016,1.69-0.399,2.21-1.103l16.215-22.189l63.477-26.042l-3.822,31.413c-0.031,0.199-0.031,0.397-0.011,0.587
                    l6.929,69.429l-7.569,16c-0.305,0.641-0.336,1.396-0.1,2.069l3.507,9.647c0.384,1.072,1.396,1.774,2.524,1.774h75.43
                    c0.898,0,1.737-0.452,2.235-1.208c0.499-0.756,0.584-1.69,0.247-2.529l-4.378-10.521c-0.419-1.008-1.4-1.657-2.488-1.657h-18.95
                    l-22.998-26.296l10.421-124.294c0.078-0.74-0.163-1.454-0.662-2.007l-7.024-7.895c-0.509-0.572-1.238-0.907-2.005-0.907h-90.547
                    l-10.231-100.624l10.421-41.649c0.073-0.294,0.1-0.591,0.068-0.903l-7.812-83.313l7.444-12.403
                    c0.541-0.887,0.52-1.997-0.063-2.858l-19.732-30.027V2.688c0-1.483-1.202-2.688-2.688-2.688h-12.278
                    c-1.396,0-2.558,1.066-2.678,2.452l-4.373,49.122c-0.036,0.304-0.005,0.601,0.068,0.892l6.915,27.644l-8.627,105.188l-3.218,1.919
                    c-0.623,0.37-1.064,1.005-1.233,1.714l-3.548,16.068l-13.774,121.389l-17.883,0.787c-0.548,0.022-1.052,0.21-1.483,0.532
                    L135.72,404.011c-0.656,0.483-1.053,1.244-1.086,2.058l-0.785,21.812l-8.627-0.551l0.753-15.776
                    c0.036-0.761-0.247-1.495-0.785-2.036c-0.544-0.535-1.302-0.803-2.042-0.776l-31.806,1.773l-30.699,4.39
                    c-0.548,0.083-1.039,0.314-1.452,0.683l-21.926,20.178c-0.555,0.504-0.866,1.229-0.866,1.974v33.324c0,0.812,0.37,1.584,1.01,2.11
                    L68.107,497.729z"
                />
              </g>
            </g>
          </svg>
          <p>Nova vježbačica</p>
        </button>

        <div class="total__clients">
          <h3>AKTIVNE :</h3>
          <h1>{{ activeClients.length }}</h1>
          <h3>OD</h3>
          <h1>{{ getAllClients.length }}</h1>
        </div>

        <search-bar
          :searchStr="search"
          :pageSizeNr="pageSize"
          @changed="setPageSize"
          @typed="searchItems"
        />
      </div>

      <div class="list__container">
        <div class="clients__heading days__list">
          <!-- <span>Ime</span> -->
          <span>Slika</span>
          <span class="sortable" @click="sortItems('last_name', true)">
            Ime
            <svg
              fill="var(--gold-light)"
              :class="sortOrder ? 'sort__asc' : 'sort__desc'"
              height="20px"
              width="20px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <path
                d="M497.552,318.828L284.686,128.883c-16.353-14.591-41.019-14.592-57.372,0.001L14.448,318.829
                C0.994,330.833-3.548,349.477,2.876,366.326c6.425,16.848,22.227,27.735,40.258,27.735h425.731
                c18.031,0,33.833-10.886,40.258-27.736C515.547,349.477,511.004,330.833,497.552,318.828z M490.062,359.057
                c-2.692,7.059-9.674,14.603-21.196,14.603H43.133c-11.523,0-18.504-7.543-21.196-14.603c-2.691-7.059-2.505-17.338,6.093-25.009
                l212.866-189.944c4.305-3.842,9.704-5.763,15.104-5.763c5.399,0,10.8,1.922,15.103,5.762l212.866,189.945
                C492.567,341.721,492.754,351.998,490.062,359.057z"
              />
            </svg>
          </span>
          <span class="sortable" @click="sortItems('group', true)">
            Grupa/Termin
            <svg
              fill="var(--gold-light)"
              :class="sortOrder ? 'sort__asc' : 'sort__desc'"
              height="20px"
              width="20px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <path
                d="M497.552,318.828L284.686,128.883c-16.353-14.591-41.019-14.592-57.372,0.001L14.448,318.829
                C0.994,330.833-3.548,349.477,2.876,366.326c6.425,16.848,22.227,27.735,40.258,27.735h425.731
                c18.031,0,33.833-10.886,40.258-27.736C515.547,349.477,511.004,330.833,497.552,318.828z M490.062,359.057
                c-2.692,7.059-9.674,14.603-21.196,14.603H43.133c-11.523,0-18.504-7.543-21.196-14.603c-2.691-7.059-2.505-17.338,6.093-25.009
                l212.866-189.944c4.305-3.842,9.704-5.763,15.104-5.763c5.399,0,10.8,1.922,15.103,5.762l212.866,189.945
                C492.567,341.721,492.754,351.998,490.062,359.057z"
              />
            </svg>
          </span>
          <!-- <span>Grupa/Termin</span> -->
          <span>Mobilni</span>
          <span class="sortable" @click="sortItems('active', false)">
            Aktivna
            <svg
              fill="var(--gold-light)"
              :class="sortOrder ? 'sort__asc' : 'sort__desc'"
              height="20px"
              width="20px"
              viewBox="0 0 512 512"
              style="enable-background: new 0 0 512 512"
              xml:space="preserve"
            >
              <path
                d="M497.552,318.828L284.686,128.883c-16.353-14.591-41.019-14.592-57.372,0.001L14.448,318.829
                C0.994,330.833-3.548,349.477,2.876,366.326c6.425,16.848,22.227,27.735,40.258,27.735h425.731
                c18.031,0,33.833-10.886,40.258-27.736C515.547,349.477,511.004,330.833,497.552,318.828z M490.062,359.057
                c-2.692,7.059-9.674,14.603-21.196,14.603H43.133c-11.523,0-18.504-7.543-21.196-14.603c-2.691-7.059-2.505-17.338,6.093-25.009
                l212.866-189.944c4.305-3.842,9.704-5.763,15.104-5.763c5.399,0,10.8,1.922,15.103,5.762l212.866,189.945
                C492.567,341.721,492.754,351.998,490.062,359.057z"
              />
            </svg>
          </span>
          <span>Aktivnosti</span>
        </div>

        <div
          v-for="client in pageOfItems"
          :key="client._id"
          class="clients__list clients__list_item"
          :class="
            setClientSchedule(client._id) === 'Nema grupu' ? 'not_schedule' : ''
          "
        >
          <div class="client__pic_wrapper" @click="selectClient(client)">
            <ClientPicture
              :picture="client.picture"
              imgSize="3em"
              class="client__pic"
            />
          </div>

          <p class="client__item" @click="selectClient(client)">
            {{ client.last_name }} , {{ client.first_name }}
          </p>
          <p class="client__item" @click="selectClient(client)">
            <!-- {{ setClientSchedule(client._id) }} -->
            {{ client.group }}
          </p>
          <p class="client__item" @click="selectClient(client)">
            {{ client.mobile }}
          </p>
          <div @click="selectClient(client)">
            <CheckboxCustom
              class="client__check"
              :checkClass="'custom__check'"
              :checkId="client._id"
              v-model="client.active"
            />
          </div>

          <button
            type="submit"
            @click="clientActivities(client)"
            class="activities_btn"
            aria-label="Client Activities"
          >
            <svg
              version="1.1"
              id="Layer_1"
              x="0px"
              y="0px"
              viewBox="0 0 1964.601 1689.422"
              enable-background="new 0 0 1964.601 1689.422"
              xml:space="preserve"
              fill="var(--purple)"
              width="30px"
              height="30px"
            >
              <path
                d="M596.675,46.812c2.36-2.565,11.24-5.634,12.609,8.424c0.289,3.583,0.834,7.15,1.884,10.597  c1.956-0.713,3.936-1.395,5.892-2.148c11.556,4.307,15.511,36.37,17.522,49.152c0.721,0.818,1.571,1.491,2.413,2.204  c0.729-9.579-1.226-19.061-1.379-28.6c-0.573-4.957,8.226-9.497,11.935,0.609c6.968,20.253,5.029,31.218,10.525,44.84  c4.736,12.226-3.164,40.206-9.507,53.24c-9.106,17.067-20.544,262.231-24.368,279.683c-2.781,7.695-8.745,14.084-10.108,22.348  c-2.593,17.2-43.237,155.024-44.784,159.664c-31.418,87.699-38.43,97.082,32.792,166.405c8.421,8.278,22.406,10,38.78,31.766  c5.416,6.775,13.147,8.325,14.148,9.018c8.823,12.217,12.337,9.556,18.588,18.308c3.976,6.132,10.292,10.116,15.919,14.564  c1.025,1.01,18.607,29.446,55.292,50.571c27.807,18.446,36.522,13.271,47.285,20.055c3.431,2.381,7.767,1.034,11.647,1.419  c62.12-2.905,233.522,48.618,331.8,124.732c1.001,0.716,149.599,112.289,162.806,121.734c94.163,62.009,77.08,1.408,297.966,144.514  c1.006,0.564,25.427,13.771,37.385,23.478c29.688,24.821,19.388,4.573,60.615,40.391c1.9,1.9,4.745,0.802,7.118,1.403  c6.22,1.972,11.952,5.186,18.164,7.214c2.661,1.836,3.375,5.395,5.09,8.032c4.048,0.633,7.431,3.086,11.23,4.481  c12.152,4.6,4.614,7.565,19.991,7.735c3.623-3.639,6.252-8.104,9.795-11.807c22.577-21.136,47.308-3.464,28.079,22.444  c8.163,7.794,22.197,3.408,37.569,18.268c27.128,26.765,61.768,6.157,77.519,45.048c11.28,30.321-8.236,58.75-28.952,83.66  c-3.744,4.416-1.505,7.441-19.703,14.885c-2.252,0.89-3.639-1.427-4.777-2.878c-37.417,2.948-29.395-28.097-45.609-32.039  c-2.255,5.811-12.012,27.69-20.24,28.448c0.825,0.761,1.659,1.563,2.485,2.405c-1.579,1.026-3.142,2.068-4.689,3.134  c0.52,4.644,1.206,2.639-9.523,18.388c-1.202-0.369-2.308-0.721-3.391-1.202c0.233,1.523,0.441,3.07,0.665,4.641  c-0.401,0.24-1.202,0.713-1.603,0.954c-1.547,2.677-3.311,5.234-5.154,7.719h-37.746c-0.369-1.611-0.681-3.222-0.938-4.825  c-13.507-8.022-20.228-22.226-21.602-29.898c-7.509-27.867-23.106-28.622-27.83-31.381c-2.704-1.541-14.573-13.786-7.078,8.513  c-0.849-1.876-1.627-3.759-2.349-5.651c-1.988,0.417-4.569,0.273-5.667,2.325c0.361,6.284,5.395,11.286,5.515,17.683  c0.397,7.816-7.246,5.933-9.787,0.457c-2.092-3.535-2.365-7.855-4.617-11.27c-2.939-0.992-21.327-2.144-15.775-20.809  c4.017-13.153,5.565-14.124,4.865-17.234c-1.011-1.012-10.21-9.586-16.937-9.298c-4.571,15.754,2.182,31.419,2.461,41.193  c-0.425-0.104-1.274-0.297-1.699-0.393c-8.353-35.231-1.981-25.612-3.791-37.145c-6.115,0.422-69.448-11.679-70.45-11.807  c-263.367-26.693-242.865-89.941-531.35-128.828c-53.383-13.928-143.985-20.266-215.974-68.43  c-121.606-68.334-146.16-177.279-261.575-200.287c-1.403-0.649-2.413-1.844-3.551-2.822c-7.414-0.89-14.019-4.769-20.881-7.447  c-2.757,0.914-4.825,3.535-8,3.174c-5.272-12.573-5.926-4.211-13.57-6.597c-4.144-1.194-8.954-2.172-11.03-6.421  c-9.597,0.932-30.588-7.967-34.179-9.579c-0.417-0.77-0.818-1.523-1.218-2.26c-1.82-0.104-3.639-0.233-5.443-0.337  c-0.008-0.385-0.016-1.154-0.024-1.539l-0.313,1.066c-9.71-4.07-8.972-0.616-13.57-2.012c-15.676-4.887-2.716-8.139-25.778-12.472  c-0.199,27.765-30.094,501.303-55.541,508.185c-13.192,5.396-25.96,15.656-28.119,17.691c-6.204,4.849-14.116,6.933-20.36,11.703  c-4.409,4.369-11.134,5.443-17.081,4.914c-0.585-4.136-2.341-8.056-2.525-12.224c1.058-4.321,4.577-7.575,5.563-11.959  c-22.464-2.678-89.33,37.46-91.627,21.482c1.72-7.911,14.761-12.244,16.552-17.073c-7.854,0.131-30.579,10.333-38.828,4.833  c-1.571-2.565-0.12-5.386,1.09-7.719c3.647-1.162,8.585-1.371,9.851-5.739c-3.086-1.884-5.707-6.012-3.31-9.426  c6.289-4.924,20.995-2.062,24.023-14.388c43.17-23.597,36.432-25.708,60.951-21.819c6.582,1.009,41.477-5.557,43.148-6.421  c11.737-9.028,10.149-14.411,11.19-17.779c4.688-15.555-6.377-99.167-13.779-131.305c-28.088-134.324,31.38-89.06-15.879-324.626  c-9.995-93.178,23.369-86.102-2.605-123.032c-1.387,0.12-2.749,0.264-4.128,0.401c-3.902-33.365,5.086-33.409-1.09-39.325  c-7.858-1.072-20.208,2.593-43.493,2.95c-1.948,5.098-3.968,10.188-6.918,14.813c-0.762-5.21-0.337-10.901-3.359-15.494  c-0.001,0.002-8.705,23.55-8.705,23.55c0.353,5.403,3.519,10.541,2.325,16.047c-0.585,3.519-2.493,6.717-2.717,10.3  c0.409,3.607,2.333,6.877,2.445,10.549c0.782,6.287-2.74,5.065,6.581,21.642c3.045,5.731,6.971,27.447,6.549,40.038  c-0.27,11.072,8.983,21.817-0.192,40.407c-0.521-2.485-0.705-5.01-0.89-7.511c-8.087,1.14-3.4,6.522-8.08,10.076  c-10.128,8.678-5.054,8.09-22.548,10.549c-0.048-0.729-0.16-2.188-0.208-2.918c-4.264,1.547-9.755,2.613-11.334,7.535  c-2.02-0.096-4.04-0.216-6.044-0.385c0.064-3.807,2.188-7.03,3.214-10.565c-0.04-3.647,0.521-7.262,2.373-10.461  c1.082-0.786,2.541-1.29,3.222-2.501c1.515-5.948,1.675-12.12,1.218-18.203c0.042-21.855,7.475-55.316,9.178-64.855  c0.633-3.198-1.659-5.924-2.124-8.961c-1.002-3.671-0.481-8-3.23-10.982c-5.226-6.308-9.018-13.987-9.418-22.284  c-8.857-1.798-9.145-6.594-10.004-10.613c-1.13-0.505-2.252-0.994-3.375-1.483c10.82-12.168,18.452-10.824,8.112-31.878  c-15.022-7.297-2.314-4.133-22.933-9.443c-1.299,0.248-2.605,0.497-3.904,0.745c-5.3-3.786-3.076-3.508-11.238-3.984  c-3.67-5.549-0.309-0.169-12.048-6.132c-1.627,0.609-2.926,2.068-4.697,2.228c-2.894-1.09-4.248-4.08-5.611-6.605  c-3.639-1.635-7.623-2.533-11.527-3.318c-0.305-0.256-0.922-0.753-1.226-1.01c-3.262-0.208-6.645-0.93-9.066-3.286  c-2.052-2.236-5.282-1.723-7.927-2.581c-1.595-0.377-1.707-2.284-2.405-3.479c-2.749-1.86-5.298-4.016-7.463-6.541  c-2.805-4-7.871-4.97-11.799-7.487c-1.408-4.661-3.152-13.1-9.955-24.568c-3.34-5.475,0.765-6.727-6.324-9.771  c-1.804-3.607-3.888-7.174-4.328-11.27c-0.377-3.399-3.767-5.531-4.144-8.905c-0.064-2.701,2.733-4.16,3.527-6.517  c4.535-29.505,5.384-40.36,20.216-54.667c3.214-4.505,4.2-10.316,8.04-14.428c1.523-1.611,2.509-3.607,3.278-5.659  c3.647-2.028,7.847-4,9.875-7.839c14.957-7.945,25.402-11.799,25.402-11.799c2.272-12.169,6.269-4.194,10.533-9.002  c2.349-2.381,5.459-3.695,8.729-4.216c8.679-13.49,28.982,1.227,38.547,0.208c9.519-1.336,19.818,14.349,34.668,7.35  c1.771-0.914,3.174,0.906,4.609,1.683c3.663,2.765,8.593,1.667,12.737,3.086c4.793,2.212,8.344,6.348,13.009,8.793  c1.651,2.757,3.102,5.683,5.387,7.992c2.95,6.145,7.953,3.058,14.124,11.783c3.399,4.817,8.938,7.607,12.128,12.609  c8.635,10.008,2.354,4.237,13.226,10.092c-1.122,0.826-2.26,1.643-3.383,2.469c0.794,2.317,3.022,3.399,4.745,4.922  c1.21,1.507,1.443,3.735,2.998,4.986c1.78,0.649,4.12-0.874,5.547,0.834c7.179,7.206,8.356,3.09,7.214,11.086  c1.667,2.91,4.248,5.09,7.27,6.517c0.152,0.521,0.465,1.563,0.617,2.084c3.062,1.659,6.573,1.571,9.955,1.715  c-0.289,0.938-0.585,1.884-0.858,2.838c1.852,3.294,2.95,7.302,6.405,9.354c3.343,2.14,5.908,5.827,10.052,6.437  c24.673,3.596,28.456-4.668,38.251-13.322c0.729-1.779,0.641-3.831,1.547-5.523c1.371-0.553,2.838-0.81,4.28-1.162  c1.147-12.043,18.42-3.877,20.472-7.903c0.625-1.347,0.593-2.87,0.818-4.296c-14.378-15.705,11.228-65.06,21.546-84.661  c0.332-0.285,29.897-50.534,35.87-57.12c32.929-37.193,71.263-142.572,71.508-176.625c2.371-58.963,54.254-160.567,48.262-267.627  c-4.523-28.298-60.953-66.095-61.953-67.091c-1.619-1.491-0.713-3.936-0.89-5.851c20.98-12.6,34.454,16.801,52.607,16.023  c8.785-3.111-1.756-70.472,10.725-75.98c3.391-2.052,6.805,1.082,9.875,2.341C594.23,51.926,594.583,48.872,596.675,46.812   M1316.434,1350.111c3.27,11.802,84.16,33.677,94.929,33.578C1403.416,1372.044,1331.87,1350.153,1316.434,1350.111   M1766.345,1433.001c-2.429,2.669-5.771,5.419-5.443,9.426c9.608,0.611,6.199,3.229,10.701,4.585  c15.014,5.129,9.494,2.344,16.569,3.92c9.379,2.249,14.285-29.369-1.651-27.43  C1778.641,1422.853,1771.563,1427.551,1766.345,1433.001 M1515.88,1426.436c0.096,4.124,60.245,29.364,67.043,28.752  c9.385,8.823,19.482,11.679,20.969,11.831c19.201,3.386,16.882,7.535,28.728,8.401c10.682,1.489,8.606,9.804,14.436,12.985  c0.754,0.358,18.792,5.918,20.095,5.907c4.144-3.864,9.466-6.204,14.941-7.503c-0.304-1.146-0.369-2.437-1.387-3.142  c-10.583-8.674-10.571-5.593-15.174-3.815C1664.531,1479.545,1529.309,1420.701,1515.88,1426.436 M1645.437,1574.959  c0.048,3.359-0.401,6.998,1.162,10.124c1.731,2.926,6.332,3.679,8.922,1.451c-0.521-4.032,0.112-8.288-1.78-12.024  c-3.217-6.842,1.567-12.032-4.345-14.22C1647.384,1564.947,1645.333,1569.781,1645.437,1574.959 M1662.943,1578.542  c0.866-0.898,1.747-1.787,2.637-2.669c-1.092-9.089-1.879-11.184-4.32-12.024  C1659.679,1567.236,1660.673,1575.655,1662.943,1578.542z"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <!-- </transition> -->

    <jw-pagination
      :items="filteredClients"
      @changePage="onChangePage"
      :initialPage="initialPage"
      :pageSize="pageSize"
      :labels="customLabels"
      :styles="customStyles"
      class="pagine"
    >
    </jw-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loading from '@/components/utils/Loading.vue';
import { customLabels, customStyles } from '@/components/utils/pageNav.js';
import SearchBar from '@/components/utils/SearchBar.vue';
import ClientPicture from '@/components/utils/ClientPicture.vue';
import CheckboxCustom from '@/components/utils/CheckboxCustom.vue';
import navigation from '@/mixins/navigation';
import navigationSearch from '@/mixins/navigationSearch';
import searchClients from '@/mixins/searchClients';
import mapSchedules from '@/mixins/mapSchedules';

export default {
  name: 'Clients',

  components: {
    Loading,
    SearchBar,
    ClientPicture,
    CheckboxCustom,
  },

  data() {
    return {
      customLabels,
      customStyles,
      sortOrder: true,
    };
  },

  mixins: [navigation, navigationSearch, searchClients, mapSchedules],

  computed: {
    ...mapGetters([
      'getAllClients',
      'getAllSchedules',
      'getClientsPage',
      'getClientsPageSize',
      'loadingState',
    ]),

    activeClients: function () {
      return this.getAllClients.filter((a) => a.active === true);
    },
  },

  methods: {
    ...mapActions([
      'fetchClients',
      'fetchClient',
      'fetchClientsPage',
      'fetchClientsPageSize',
      'fetchFromForm',
      'clientClear',
      'fetchSchedules',
      'setLoadingState',
    ]),

    async newClient() {
      this.setLoadingState(true);
      this.$router.push('/client');
      await this.clientClear();
    },

    async selectClient(client) {
      this.setLoadingState(true);
      await this.fetchClient(client);
      this.setPageNr();
      this.$router.push('/client');
    },

    async clientActivities(client) {
      this.setLoadingState(true);
      await this.fetchClient(client);
      this.fetchFromForm('clients');
      this.setPageNr();
      this.$router.push('/clientactivity');
    },

    sortItems(field, type) {
      this.sortOrder = !this.sortOrder;
      this.filteredClients.sort((a, b) => {
        let x, y;
        if (!type) {
          x = a[field];
          y = b[field];
        } else {
          x = a[field].toLowerCase();
          y = b[field].toLowerCase();
        }
        //return this.sortOrder ? x > y : x < y;
        if (this.sortOrder) {
          return x > y ? -1 : 1;
        } else {
          return x > y ? 1 : -1;
        }
      });
    },

    async searchItems(val = '') {
      await this.initItems();
      let mu = this.getAllClients.filter((post) => {
        return (
          post.name.toLowerCase().includes(val.toLowerCase()) ||
          post.email.toLowerCase().includes(val.toLowerCase()) ||
          post.mobile.includes(val)
        );
      });
      this.filteredClients = mu;
    },

    async initItems() {
      if (!this.getAllClients.length) await this.fetchClients();
      this.filteredClients = this.getAllClients.sort((a, b) =>
        a.last_name.toLowerCase() > b.last_name.toLowerCase() ? 1 : -1
      );
      if (!this.getAllSchedules.length) await this.fetchSchedules();
      for (let i = 0; i < this.filteredClients.length; i++) {
        this.filteredClients[i].group = this.setClientSchedule(
          this.filteredClients[i]._id
        );
      }
      if (this.getClientsPage !== 1) this.initialPage = this.getClientsPage;
      if (this.getClientsPageSize !== 10)
        this.pageSize = this.getClientsPageSize;
    },
  },

  async mounted() {
    await this.initItems();
    await this.setLoadingState(false);
  },
};
</script>

<style>
.client__active_check {
  text-align: center;
}

.client__check {
  pointer-events: none;
}

.client__pic_wrapper {
  cursor: pointer;
}

.client__pic {
  justify-self: center;
  transition: all 0.4s ease;
}

.client__pic:hover {
  transform: scale(1.3);
}
</style>
